import request from '@/http/request'

const base = `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/special/sku/configuration`

export const getTableData = params => {
  return request.post(`${base}/findSpecialSkuConfigurationPage`, params)
}

export const addData = params => {
  return request.post(`${base}/add`, params, { hiddenError: true })
}

export const updateData = params => {
  return request.post(`${base}/update`, params, { hiddenError: true })
}

/** 产品代码回车解析 Product Name */
export const queryProductByCode = params => {
  return request.get(`${base}/validateProductCode`, { params: params, hiddenError: true })
}

export const getDropDownPlants = () => {
  return request.get(`${base}/getDropDownPlants`, { hiddenError: true })
}
export const getPlantList = () => {
  return request.get(`${base}/getPlantList`)
}

export const disableRecords = id => {
  return request.get(`${base}/disable/${id}`)
}

export const downloadData = params => {
  return request.post(`${base}/exportSpecialSkuConfiguration`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
